<template>
  <div v-if="task" class="task-modal-backdrop" @click.self="$emit('close')">
    <section class="task-modal" role="dialog" aria-modal="true" aria-labelledby="task-detail-title">
      <header>
        <div><span class="modal-eyebrow">DESIGN TASK</span><h2 id="task-detail-title">订单任务详情</h2></div>
        <button type="button" class="modal-close" aria-label="关闭" @click="$emit('close')"><X :size="18" /></button>
      </header>
      <div class="detail-status-line"><span class="task-status" :class="`tone-${statusInfo.tone}`">{{ statusInfo.label }}</span><strong>{{ task.orderNo }}</strong></div>
      <div class="detail-grid">
        <div><span>客户旺旺/名称</span><strong>{{ task.customerDisplay }}</strong></div>
        <div><span>客户电话</span><strong>{{ task.customerPhone || '-' }}</strong></div>
        <div><span>店铺</span><strong>{{ task.storeName }}</strong></div>
        <div><span>产品分类</span><strong>{{ task.productCategory }}</strong></div>
        <div><span>客服</span><strong>{{ task.serviceName }}</strong></div>
        <div><span>设计师</span><strong>{{ task.designerName || '-' }}</strong></div>
        <div><span>下单时间</span><strong>{{ task.orderTime }}</strong></div>
        <div><span>任务创建时间</span><strong>{{ task.taskCreatedTime || '-' }}</strong></div>
        <div><span>指派方式</span><strong>{{ task.sourceType === 1 ? '被指定' : task.sourceType === 2 ? '自己领取' : '-' }}</strong></div>
        <div><span>订单来源</span><strong>{{ orderSourceLabel }}</strong></div>
      </div>
      <div v-if="task.designRemark" class="detail-note"><span>设计备注</span><p>{{ task.designRemark }}</p></div>
      <div v-if="task.returnReason" class="detail-note danger"><span>退回原因</span><p>{{ task.returnReason }}</p></div>
      <footer><button type="button" class="filter-reset" @click="$emit('close')">关闭</button><button v-if="canStart" type="button" class="filter-search" @click="$emit('start', task)">{{ task.status === 'DESIGNING' ? '继续设计' : '开始设计' }}</button></footer>
    </section>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { X } from '@lucide/vue';
import { canStartDesignerTask, designerTaskStatusMeta } from '@/services/designerTaskService';

const props = defineProps({ task: { type: Object, default: null } });
defineEmits(['close', 'start']);
const statusInfo = computed(() => designerTaskStatusMeta[props.task?.status] || { label: props.task?.status || '未知状态', tone: 'muted' });
const canStart = computed(() => canStartDesignerTask(props.task?.status));
const sourceMap = { 1: '淘宝', 2: '天猫', 3: '1688', 4: '国际站', 5: '企业微信', 6: '拼多多' };
const orderSourceLabel = computed(() => sourceMap[props.task?.orderSource] || '-');
</script>
